import { render } from "./AdminMigratePlayers.vue?vue&type=template&id=44e43e83&scoped=true"
import script from "./AdminMigratePlayers.vue?vue&type=script&lang=js"
export * from "./AdminMigratePlayers.vue?vue&type=script&lang=js"

import "./AdminMigratePlayers.vue?vue&type=style&index=0&id=44e43e83&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e43e83"]])

export default __exports__